module.exports = __webpack_public_path__ + "media/images/flags/gs-a72696cf79bb09dc341398aedd11c274.svg";